module.exports = __webpack_public_path__ + "img/124.c448a89a.jpg";